import * as React from 'react';
import { FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import { SegmentAttributeOperator } from '../../../models/segments';
import { colors } from '../../../theme/colors';

interface Props {
  disabled?: boolean;
  operator: SegmentAttributeOperator;
  handleChange: (operator: SegmentAttributeOperator) => void;
}

const useStyles = makeStyles({
  inputs: {
    margin: '4px 12px',
    flex: '0 0 96px',
    '& .MuiInputLabel-root': {
      backgroundColor: '#f8f8f8'
    },
    '& .MuiInputLabel-asterisk': {
      color: colors.rustRed
    }
  }
});

/**
 * AND/OR Attribute group operator
 */
const OperatorSelect = ({ disabled, operator, handleChange }: Props) => {
  const overrides = useStyles();
  const id = React.useId();
  return (
    <FormControl required size="small" variant="outlined" className={overrides.inputs}>
      <InputLabel htmlFor={`select-operator-${id}`}>And/Or</InputLabel>
      <Select
        id={`select-operator-${id}`}
        value={operator}
        onChange={(event) => {
          handleChange(event.target.value as SegmentAttributeOperator);
        }}
        disabled={disabled}
        required
      >
        <MenuItem value={SegmentAttributeOperator.And}>And</MenuItem>
        <MenuItem value={SegmentAttributeOperator.Or}>Or</MenuItem>
      </Select>
    </FormControl>
  );
};

export default OperatorSelect;
